import { createFileRoute } from "@tanstack/react-router";
import PressureWasherSubcategoryLanding from "@/pages/PressureWasherSubcategoryLanding";

export const Route = createFileRoute("/pressure-washers/category/$slug")({
  component: PressureWasherSubcategoryLanding,
});
